import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Link from '../utils/link';

import useProjectsQuery from '../hooks/use-projects-query';

const Projects = () => {
  const { allWpProject } = useProjectsQuery();
  const projects = JSON.parse(JSON.stringify(allWpProject));
  const [filteredProjects, setFilteredProjects] = React.useState(projects.nodes);
  const [primaryFilter, setPrimaryFilter] = React.useState('');
  const [secondaryFilter, setSecondaryFilter] = React.useState('');

  const filterProjects = (primary, secondary) => {
    let fp = projects.nodes.filter((project) => {
      const category = project.acf.filter; // Assuming `acf.filter` contains categories
      const matchesPrimary = primary ? category.includes(primary) : true;
      const matchesSecondary = secondary ? category.includes(secondary) : true;
      return matchesPrimary && matchesSecondary;
    });
    setFilteredProjects(fp);
  };

  const handlePrimaryFilter = (filter) => {
    setPrimaryFilter(filter);
    setSecondaryFilter(''); // Reset secondary filter when primary changes
    filterProjects(filter, '');
  };

  const handleSecondaryFilter = (filter) => {
    setSecondaryFilter(filter);
    filterProjects(primaryFilter, filter);
  };

  return (
    <>
      <section className="filter">
        <ul>
          <li
            className={primaryFilter === 'city' ? 'active' : ''}
            onClick={() => handlePrimaryFilter('city')}
          >
            City
          </li>
          <li
            className={primaryFilter === 'country' ? 'active' : ''}
            onClick={() => handlePrimaryFilter('country')}
          >
            Country
          </li>
        </ul>

        {/* Secondary Filter */}
        {primaryFilter && (
          <ul className='filter__secondary'>
            <li
              className={secondaryFilter === 'upcoming' ? 'active' : ''}
              onClick={() => handleSecondaryFilter('upcoming')}
            >
              Coming Soon
            </li>
            <li
              className={secondaryFilter === 'in_development' ? 'active' : ''}
              onClick={() => handleSecondaryFilter('in_development')}
            >
              Under Construction
            </li>
            <li
              className={secondaryFilter === 'completed' ? 'active' : ''}
              onClick={() => handleSecondaryFilter('completed')}
            >
              Complete
            </li>
          </ul>
        )}
      </section>

      <section className="media media--projects">
        <div className="media__inner">
          {filteredProjects.map(({ title, uri, acf }, index) => (
            <Link className="media__item" key={index} to={uri}>
              <div className="latest-media">
                <GatsbyImage image={getImage(acf.gallery[0]?.localFile)} alt={title} />
                <h2>{title}</h2>
                <p>{acf.tag}</p>
              </div>
            </Link>
          ))}
          { filteredProjects.length === 0 && <p className='media__no-results'>No projects found</p> }
        </div>
      </section>
    </>
  );
};

export default Projects;
